/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Col_WebInputs */

const en_pc_online_cmp_col_web = /** @type {(inputs: Pc_Online_Cmp_Col_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online`)
};

const zh_pc_online_cmp_col_web = /** @type {(inputs: Pc_Online_Cmp_Col_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online" |
*
* @param {Pc_Online_Cmp_Col_WebInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_col_web = /** @type {((inputs?: Pc_Online_Cmp_Col_WebInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Col_WebInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_col_web(inputs)
	return zh_pc_online_cmp_col_web(inputs)
});
export { pc_online_cmp_col_web as "pc.online.cmp.col_web" }